import { getDefaultClient } from '../../../client/defaultClient';
import { assertDefined } from '../../../utils/assertDefined';

/**
 * Checks if the user requires additional MFA authentication.
 *
 * This function determines if the current user session requires
 * additional multi-factor authentication to access certain features.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns True if the user needs additional MFA authentication, false otherwise.
 */
export const isUserMissingMfaAuth = (client = getDefaultClient()) => {
  const user = client.user;

  assertDefined(user, 'User not logged in');

  return Boolean(user.scope?.includes('requiresAdditionalAuth'));
};
